import { SEARCH_VALUE } from '@/constants';
import { storage } from '@/utils';

export default {
  /**
   * 设置本地搜索缓存
   * @param searchValue
   * @param callback
   */
  localSet: (searchOptions: { key?: string; value: string }, callback?: () => void) => {
    const searchKey = searchOptions.key || SEARCH_VALUE;
    const searchValue = searchOptions.value;
    if (searchValue) {
      const cache: string[] = storage.get(searchKey) ?? [];
      // 查找是否已经存在
      const index = cache.findIndex((it) => it === searchValue);
      // 存在则提升到第一项
      if (index >= 0) {
        cache.splice(index, 1);
        cache.unshift(searchValue);
      } else {
        // 不存在则添加至第一项
        cache.unshift(searchValue);
      }
      storage.set(searchKey, cache);
    }
    callback?.();
  },
};
